module.exports = __webpack_public_path__ + "static/logo-reply-logistics-593ca3331ad09d69a147dc88fe569a62.webp";